import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-hd gfu-hd--h2 _mb-1" }
const _hoisted_2 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_base_slider = _resolveComponent("base-slider")

  return (_openBlock(), _createElementBlock("aside", null, [
    _createVNode(_component_base_slider, {
      "data-nosnippet": "",
      items: $options.recommendationsItems,
      "extra-large-screen-visible-items-count": $props.extraLargeScreenVisibleItemsCount,
      "large-screen-visible-items-count": $props.largeScreenVisibleItemsCount,
      "medium-screen-visible-items-count": $props.mediumScreenVisibleItemsCount,
      "small-screen-visible-items-count": $props.smallScreenVisibleItemsCount,
      "slide-gap-classes": "_px-2 _px-3--m",
      "scroll-container-wrapper-classes": "_pos-r _-mx-2 _-mx-3--m",
      "is-processing": _ctx.isProcessing,
      onGetItems: $options.getRecommendationItems,
      onScrollLeft: $options.onScrollLeft,
      onScrollRight: $options.onScrollRight
    }, {
      prefix: _withCtx(() => [
        _createElementVNode("h2", _hoisted_1, _toDisplayString($options.recommendationTitle), 1 /* TEXT */),
        _createVNode(_component_localize, {
          resource: _ctx.Resources.ProjectHome.ProjectRecommendationsText
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              "format-key": "0",
              class: "gfu-link gfu-link--accent",
              href: $options.searchUrl
            }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectRecommendationsSearchLink), 9 /* TEXT, PROPS */, _hoisted_2)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["items", "extra-large-screen-visible-items-count", "large-screen-visible-items-count", "medium-screen-visible-items-count", "small-screen-visible-items-count", "is-processing", "onGetItems", "onScrollLeft", "onScrollRight"])
  ]))
}